import React from "react"
import { StaticImage } from "gatsby-plugin-image"

const ImageMO21 = () => {

  return (
    <StaticImage
      src="../../images/JPG-MALE-LOOK002-1.jpg"
      
      alt="Reserved avatar"
    />
  )
}

export default ImageMO21
